export default "__VITE_ASSET__599l59t9__"